import { render } from "./PanelShare.vue?vue&type=template&id=0dff81a4&scoped=true&ts=true"
import script from "./PanelShare.vue?vue&type=script&lang=ts"
export * from "./PanelShare.vue?vue&type=script&lang=ts"

import "./PanelShare.vue?vue&type=style&index=0&id=0dff81a4&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src602189598/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dff81a4"]])

export default __exports__